<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">一致性檢查</h1>
                        <h2>讓你的寫作更專業</h2>
                        <p>Trinka 的一致性檢查功能能夠修正難以察覺的用字不一致問題，特別適用於篇幅較長的文件。節省寶貴時間，讓您的寫作更專業、更一致。 <br/>此功能支援英文與西班牙文。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/features/consistency-checks/Consistency-Checks.webp" width="360" height="360" class="" alt="consistency-check" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="../../../../assets/images/yt-thumbnail/ConsistencyCheckThumbnail.webp" width="800" height="450" alt="consistency-check" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「一致性檢查」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p class="mb-0">還有其他問題嗎？歡迎瀏覽我們的常見問答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cloud_key_features section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>一致性檢查主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-70">Trinka 幫你一一揪出細節錯誤，從用字到格式，全面修正，提升專業度。<br/>Trinka能夠識別並糾正以下類型的寫作不一致。</p>
                </div>
            </div>
            <div class="col-12">
                <div class="trinkaToggleButton justify-content-center mt-2 mb-2">
                    <div class="trinkaToogleWrapper bg-grey">
                        <p>英文</p>
                        <label class="switch" style="margin: 0 8px;">
                            <input type="checkbox" [(ngModel)]="showLanguages" checked />
                            <span class="slider-rd round"></span>
                        </label>
                        <p>西班牙文</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="english" [ngClass]="{'hidden': showLanguages}">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="feature_num">01</div>
                        <h3>拼寫</h3>
                        <p>Trinka可以識別同一單詞的不同拼寫，比如美式與英式拼音 。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="colourSection" name="spellingchecks" checked>
                                <label for="colourSection">colour (4 occurences) </label>
                            </p>
                            <p>
                                <input type="radio" id="colorSections" name="spellingchecks">
                                <label for="colorSections">color (4 occurences) </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">02</div>
                        <h3>連字號和破折號</h3>
                        <p>Trinka 能偵測並修正連字號與破折號使用不一致的問題，輕鬆一鍵讓格式統一。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                <label for="ultra-violet">ultra-violet (5 occurrences)
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="ultra_violet" name="dashesCehcks">
                                <label for="ultra_violet">ultra violet (5 occurrences)
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">03</div>
                        <h3>編號樣式</h3>
                        <p>數字與文字數字混用是最常見的不一致的問題之一，Trinka 幫你一鍵避免這種錯誤。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="averagesixyears" name="sadfdashesCehcks" checked>
                                <label for="averagesixyears">
                                    <b>average six years</b>
                                        <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>average 6 years</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="averagesixyearsss" name="sadfdashesCehcks">
                                <label for="averagesixyearsss">
                                    <b>average 6 years</b>
                                        <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>average six years</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">04</div>
                        <h3>符號</h3>
                        <p class="fearureCardText">Trinka 能辨識你交替使用符號或全文拼寫的情況，並幫助你保持一致。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one" name="exampeFourContent" checked>
                                <label for="exampeFourContent_one">
                                    <b>TNF-alpha</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" /><b>TNF-α</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two" name="exampeFourContent">
                                <label for="exampeFourContent_two">
                                    <b>TNF-α</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>TNF-alpha</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">05</div>
                        <h3>間距</h3>
                        <p class="fearureCardText">寫作中多餘的空格很難發現，因此很容易錯過。只需在Trinka中按一下幾下，即可幫助您消除整個寫作過程中不一致的間距 。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFiveContent_one" name="exampeFiveContent" checked>
                                <label for="exampeFiveContent_one">
                                    <b>p<0</b> 
                                    <img src="/assets/images/spacingArrow.png" alt="icon" /> 
                                    <b>p < 0</b> 
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFiveContent_two" name="exampeFiveContent">
                                <label for="exampeFiveContent_two">
                                    <b>p < 0</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>p<0</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">06</div>
                        <h3 class="d-block">標題 （表格、圖表、方框） <div class="beta-badge">NEW</div> </h3>
                        <p class="fearureCardText">Trinka 能一鍵搞定表格、圖表和方框的標題不一致問題，讓整篇文件標題風格統一。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeSixContent_one" name="exampeSixContent" checked>
                                <label for="exampeSixContent_one">
                                    <b>Figure 1.</b> 
                                    <img src="/assets/images/spacingArrow.png" alt="icon" /> 
                                    <b>Fig 1.</b> 
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeSixContent_two" name="exampeSixContent">
                                <label for="exampeSixContent_two">
                                    <b>Fig 1.</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>Figure 1.</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">07</div>
                        <h3>P 值格式統一 <div class="beta-badge">NEW</div></h3>
                        <p class="fearureCardText">Trinka 確保您的 P 值表達方式在大小寫、間距和是否帶有前導零方面都能保持一致，讓統計呈現更標準、專業。 </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeSevenContent_one" name="exampeSevenContent" checked>
                                <label for="exampeSevenContent_one">
                                    <b>p < 0.01</b> 
                                    <img src="/assets/images/spacingArrow.png" alt="icon" /> 
                                    <b>p < .01</b> 
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeSevenContent_two" name="exampeSevenContent">
                                <label for="exampeSevenContent_two">
                                    <b>p < .01</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>p < 0.01</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">08</div>
                        <h3>Date Formats</h3>
                        <p class="fearureCardText">Trinka automatically detects inconsistencies in date expressions and <span class="yellow-bg">ensures a uniform date format</span> in your document.</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeEightContent_one" name="exampeEightContent" checked>
                                <label for="exampeEightContent_one">
                                    <b>20 April 2024</b> 
                                    <img src="/assets/images/spacingArrow.png" alt="icon" /> 
                                    <b>20 April, 2024</b> 
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeEightContent_two" name="exampeEightContent">
                                <label for="exampeEightContent_two">
                                    <b>20 April, 2024  </b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>20 April 2024</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div> -->

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="feature_num">08</div>
                        <h3 class="d-block">帶重音字元檢查 <div class="beta-badge">NEW</div></h3>
                        <p class="fearureCardText">Trinka 能檢查您文稿中所有帶有重音符號的字元是否前後一致，避免格式混亂。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeEightContent_one" name="exampeEightContent" checked>
                                <label for="exampeEightContent_one">
                                    <b>café</b> 
                                    <img src="/assets/images/spacingArrow.png" alt="icon" /> 
                                    <b>cafe</b> 
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeEightContent_two" name="exampeEightContent">
                                <label for="exampeEightContent_two">
                                    <b>cafe</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>café</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="spanish" [ngClass]="{'hidden': !showLanguages}">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">01</div>
                        <h3>Estilo de números</h3>
                        <p class="fearureCardText">El uso intercambiable de <span>numerales y números deletreados</span> es una de las inconsistencias más comunes. Trinka le ayuda a evitarlo con un clic.</p>
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagefouryears_Spanish" name="sadfdashesCehcks_Spanish" checked />
                                    <label for="averagefouryears_Spanish">
                                        <b>4 manzanas</b>
                                        <img src="/assets/images/spacingArrow.png" alt="icon" />
                                        <b>uatro manzanas</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="averagefouryears" name="sadfdashesCehcks_Spanish" />
                                    <label for="averagefouryears_Spanish">
                                        <b>6 sillas</b>
                                        <img src="/assets/images/spacingArrow.png" alt="icon" />
                                        <b>seis sillas</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">02</div>
                        <h3>Títulos (Tablas, Figuras, Cajas)</h3>
                        <p class="fearureCardText">Trinka corrige las inconsistencias en los títulos de las tablas, figuras y cuadros, con un solo clic.</p>
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagesixyears_Spanish" name="cajas" checked />
                                    <label for="averagesixyears_Spanish">
                                        <b>Figura 1</b>
                                        <img src="/assets/images/spacingArrow.png" alt="icon" />
                                        <b>Fig. 1</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="averagesixyears_Spanish" name="cajas" />
                                    <label for="averagesixyears_Spanish">
                                        <b>Fig. 3</b>
                                        <img src="/assets/images/spacingArrow.png" alt="icon" />
                                        <b>Figura 3</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <div class="feature_num">03</div>
                        <h3>
                            Simbolos<br class="d-lg-block d-none" />
                            &nbsp;
                        </h3>
                        <p class="fearureCardText">
                            Trinka entiende cuando hace uso intercambiable de
                            <span>símbolos o los deletrea.</span>
                        </p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one_Spanish" name="exampeFourContentSpanish" checked />
                                <label for="exampeFourContent_one_Spanish">
                                    <b>TNF-alfa</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>TNF-α</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two_Spanish" name="exampeFourContentSpanish" />
                                <label for="exampeFourContent_two_Spanish">
                                    <b>TNF-beta</b>
                                    <img src="/assets/images/spacingArrow.png" alt="icon" />
                                    <b>TNF-β</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">讓你的寫作，維持一致且專業！</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="bg-light">
    <app-security-section></app-security-section>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 的 一致性檢查如何使用？
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 的一致性檢查會自動偵測常見的用字與格式變異，並將所有問題一一列出，還會提供修正建議。您只需選擇合適的風格並確認，剩下的交給 Trinka 幫您搞定。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">在那裡可以找到 一致性檢查功能？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>一致性檢查功能目前已在雲端編輯器中供所有用戶使用。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        使用一致性檢查需要多少點數?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前使用一致性檢查功能不需要花費點數。您可以根據需要多次使用該功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        什麼時候適合使用一致性檢查功能？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>建議在完成寫作後使用一致性檢查，不過這個功能沒有使用限制，只要您覺得有需要，隨時都可以使用。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/hTaMLLHICCo"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>
